import React from 'react';

import CheckboxInput from '../CheckboxInput';

const PendingArrangementActionBar = ({
  selectAll,
  allCheckbox,
  handleChangeType,
  handleMassAction,
}) => {
  return (
    <div className="pending-arrangement-action-bar">
      <div className="checkbox-wrapper">
        <CheckboxInput
          label="Check all"
          input={{
            checked: allCheckbox,
            onChange: selectAll,
          }}
        />
      </div>
      <div className="links-wrapper">
        <button
          className="button-as-link button_link mar-r"
          onClick={() => handleChangeType('all')}
        >
          Show all
        </button>
        <button
          className="button-as-link button_link mar-r"
          onClick={() => handleChangeType('pending_arrangement')}
        >
          Show pending
          <br />
          arrangements
        </button>
        <button
          className="button-as-link button_link mar-r"
          onClick={() => handleChangeType('arranged')}
        >
          Show arranged
        </button>
        <button
          className="button-as-link button_link mar-r"
          onClick={() => handleChangeType('denied_arrangement')}
        >
          Show denied
          <br />
          arrangements
        </button>
      </div>
      <div className="buttons-wrapper">
        <button
          className="btn btn-default mar-r"
          onClick={() => handleMassAction('arranged')}
        >
          Approve
        </button>
        <button
          className="btn btn-default mar-r"
          onClick={() => handleMassAction('denied_arrangement')}
        >
          Deny
        </button>
        <button
          className="btn btn-default mar-r"
          onClick={() => handleMassAction('overdue')}
        >
          Set overdue
        </button>
      </div>
    </div>
  );
};

export default PendingArrangementActionBar;
